/**
 * Maps technical error messages to user-friendly messages
 * @param errorMessage - The technical error message
 * @returns A user-friendly error message
 */
export const getUserFriendlyErrorMessage = (errorMessage: string): string => {
  const message = errorMessage.toLowerCase()

  if (message.includes('user is not a member of any group')) {
    return 'The selected user is not associated with any group. Please select a different user or contact support if this issue persists.'
  }

  if (message.includes('network') || message.includes('fetch')) {
    return 'There was a problem loading data. Please check your internet connection and try again.'
  }

  if (message.includes('authentication') || message.includes('unauthorized')) {
    return 'There was an authentication issue. Please try logging in again.'
  }

  if (message.includes('permission') || message.includes('forbidden')) {
    return 'You do not have permission to access this resource. Please contact support.'
  }

  if (message.includes('loading') || message.includes('timeout')) {
    return 'The application is taking longer than expected to load. Please try again.'
  }

  return 'An unexpected error occurred. Please try refreshing the page or contact support if the problem persists.'
}

/**
 * Extracts error message from Error object or string
 * @param error - Error object or string
 * @returns The error message string
 */
export const getErrorMessage = (error: Error | string): string => {
  return typeof error === 'string' ? error : error.message
}
